import { HttpClient } from '@angular/common/http';
import { UrlService } from './url.service';
import { Observable } from 'rxjs';
import { AnalyticalCategoryDto } from 'app/@types/dto/analytical-category-dto.model';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AnalyticalCategoriesHttpService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    getAll(orgId: string): Observable<AnalyticalCategoryDto[]> {
        return this.http.get<AnalyticalCategoryDto[]>(this.urlService.getAnalyticalCategoriesUrl(orgId));
    }

    create(analyticCategory: AnalyticalCategoryDto, orgId: string): Observable<AnalyticalCategoryDto> {
        return this.http.post<AnalyticalCategoryDto>(
            this.urlService.getAnalyticalCategoriesUrl(orgId),
            analyticCategory,
        );
    }

    update(analyticCategory: AnalyticalCategoryDto, orgId: string): Observable<AnalyticalCategoryDto> {
        return this.http.put<AnalyticalCategoryDto>(
            this.urlService.getAnalyticalCategoriesUrl(orgId),
            analyticCategory,
        );
    }

    delete(analyticCategoryId: string, orgId: string): Observable<AnalyticalCategoryDto> {
        return this.http.delete<AnalyticalCategoryDto>(
            this.urlService.getAnalyticalCategoriesDeleteUrl(orgId, analyticCategoryId),
        );
    }
}
